import Vue from 'vue'

const EventBus = new Vue()

Vue.prototype.$eventbus = EventBus

export default EventBus



// WEBPACK FOOTER //
// ./src/plugins/event-bus.js